<main class="c-content">
  <div class="c-content__info">
    <p class="is-title">Equipamento</p>
    <app-card [data]="cardData"></app-card>
  </div>

  <form class="c-content__form" [formGroup]="form" (ngSubmit)="prosseguir()">
    <fieldset class="c-content__fieldset">
      <div class="div__checkbox">
        <input
          class="input__checkbox"
          #userInfoCheckboxElement
          (change)="preencherFormUsuario(userInfoCheckboxElement.checked)"
          type="checkbox"
          name="userInfo"
          id="userInfo"
        />
        <label for="userInfo" class="checkbox-label">
          Preencher com informações do usuário conectado
        </label>
      </div>

      <label for="contato" class="c-content__label">
        <span class="label-text">Nome do Contato *</span>
        <input
          class="c-content__input"
          required
          name="contato"
          formControlName="contato"
          maxLength="20"
        />
      </label>

      <label for="celular" class="c-content__label">
        <div class="div-message">
          <span class="label-text">Celular</span>
          <p class="message">
            (Ao menos um número para contato deve ser informado.)
          </p>
        </div>
        <input
          class="c-content__input"
          name="celular"
          formControlName="celular"
          mask="(00) 00000-0000"
        />
        <app-mensagem-erro-input
          *ngIf="
            form.errors?.aoMenosUmPreenchido && form.get('celular')?.touched
          "
        >
          Ao menos um número para contato deve ser informado.
        </app-mensagem-erro-input>
        <app-mensagem-erro-input
          *ngIf="
            form.get('celular')?.errors?.mask && form.get('celular')?.touched
          "
        >
          Celular inválido.
        </app-mensagem-erro-input>
      </label>

      <label for="fone" class="c-content__label">
        <span class="label-text">Telefone</span>
        <input
          class="c-content__input"
          name="fone"
          formControlName="fone"
          mask="(00) 0000-0000"
        />
        <app-mensagem-erro-input
          *ngIf="form.errors?.aoMenosUmPreenchido && form.get('fone')?.touched"
        >
          Ao menos um número para contato deve ser informado.
        </app-mensagem-erro-input>
        <app-mensagem-erro-input
          *ngIf="form.get('fone')?.errors?.mask && form.get('fone')?.touched"
        >
          Telefone inválido.
        </app-mensagem-erro-input>
      </label>

      <label for="foneaux" class="c-content__label">
        <span class="label-text">Telefone alternativo</span>
        <input
          class="c-content__input"
          name="foneaux"
          formControlName="foneaux"
          mask="(00) 0000-00009"
        />
        <app-mensagem-erro-input
          *ngIf="
            form.errors?.aoMenosUmPreenchido && form.get('foneaux')?.touched
          "
        >
          Ao menos um número para contato deve ser informado.
        </app-mensagem-erro-input>
        <app-mensagem-erro-input
          *ngIf="
            form.get('foneaux')?.errors?.mask && form.get('foneaux')?.touched
          "
        >
          Telefone alternativo inválido.
        </app-mensagem-erro-input>
      </label>

      <app-botao-submit class="c-content__submit" [disabled]="form.invalid"
        >Continuar</app-botao-submit
      >
    </fieldset>
  </form>
</main>
